import { BrandDetailItemProps } from "./constants"
import MOOIMOM from "./MOOIMOM"
import MUGU from "./MUGU"
import NeroBianco from "./NeroBianco"
import Tweeling from "./Tweeling"


const Brand = (props: BrandDetailItemProps) => {

  return (
    <>
      {props.slug === "mooimom" && (
        <MOOIMOM
          slug={props.slug}
          main_banner={props.main_banner}
          our_picks={props.our_picks}
          people_say={props.people_say}
          instagram={props.instagram}
          shopping_category={props.shopping_category}
          info_banner={props.info_banner}
          shopping_banners={props.shopping_banners}
        />
      )}
      {props.slug === "mugu" && (
        <MUGU
          slug={props.slug}
          main_banner={props.main_banner}
          our_picks={props.our_picks}
          people_say={props.people_say}
          instagram={props.instagram}
          shopping_category={props.shopping_category}
          info_banner={props.info_banner}
          shopping_banners={props.shopping_banners}
        />
      )}
      {props.slug === "tweeling" && (
        <Tweeling
          slug={props.slug}
          main_banner={props.main_banner}
          our_picks={props.our_picks}
          people_say={props.people_say}
          instagram={props.instagram}
          shopping_category={props.shopping_category}
          info_banner={props.info_banner}
          shopping_banners={props.shopping_banners}
        />
      )}
      {props.slug === "nero-bianco" && (
        <NeroBianco
          slug={props.slug}
          main_banner={props.main_banner}
          our_picks={props.our_picks}
          people_say={props.people_say}
          instagram={props.instagram}
          shopping_category={props.shopping_category}
          info_banner={props.info_banner}
          shopping_banners={props.shopping_banners}
        />
      )}
    </>
  )
}

export default Brand
